var _defs, _tspan, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTs64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "56.652809mm",
    height: "132.29167mm",
    viewBox: "0 0 56.652809 132.29167",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-1.1526011e-7,-164.70833)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g249",
    transform: "matrix(1.3693739,0,0,1.3693739,-15.471267,-20.490324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "text108",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE086"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path239",
    d: "m 37.866411,149.79543 c 1.202654,1.20266 2.766106,1.68372 4.329557,1.68372 0.721593,0 1.683716,-0.24053 2.405309,-0.48106 3.006637,-0.72159 5.291681,-3.8485 5.291681,-6.85513 0,-0.3608 0,-0.7216 -0.120265,-1.08239 -0.481062,-3.1269 -3.126903,-5.53221 -6.013274,-6.49434 -2.285044,-0.96212 -5.171415,-1.32292 -7.576725,-1.32292 -7.336194,0.12027 -14.191326,3.72823 -17.679024,10.22257 -2.044513,4.08902 -3.72823,9.14017 -3.72823,13.71026 v 0.3608 c 0.120266,4.44982 0.841858,9.3807 3.006637,13.2292 2.044513,3.72823 5.291681,7.57672 9.01991,9.26044 2.40531,1.08239 5.291681,1.32292 7.696991,1.32292 4.329557,0 9.140175,-0.60133 12.627874,-3.4877 3.367433,-2.64584 5.532212,-6.9754 5.532212,-11.30495 0,-5.41195 -2.886371,-8.65912 -5.893008,-10.94416 -2.645841,-1.92425 -5.652478,-3.00664 -8.659114,-3.00664 -3.006637,0 -6.253805,1.20266 -8.659114,3.36744 -0.240531,0.24053 -0.481062,0.24053 -0.601328,0.24053 -0.601327,0 -0.841858,-0.84186 -0.841858,-2.40531 0.240531,-17.79929 5.893008,-18.28035 7.937521,-18.28035 1.924248,0 3.126902,0.48106 3.126902,1.44318 0,1.44319 -1.803982,2.52558 -2.405309,3.72823 -0.481062,0.84186 -0.601327,1.80398 -0.601327,2.76611 0,1.44318 0.481062,2.88637 1.443185,3.96876 0.120266,0.12026 0.240531,0.24053 0.360797,0.36079 z m -3.607964,9.38071 c 3.006636,0 5.652477,4.81062 5.652477,10.82389 0,6.01328 -2.645841,10.8239 -5.652477,10.8239 -3.126903,0 -5.652478,-4.81062 -5.652478,-10.8239 0,-6.01327 2.525575,-10.82389 5.652478,-10.82389 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "text39",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "120.26547241px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.62638098
    },
    "aria-label": "\\uE084"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "m 44.250799,214.89329 v -20.5654 c 0,-0.72159 -0.120266,-1.68372 -1.202655,-1.68372 -0.841858,0 -1.32292,0.24053 -1.924248,0.96213 l -9.140175,11.06442 c -0.360797,0.48106 -0.841859,0.96212 -0.841859,2.16478 v 8.05779 H 18.153191 c 7.69699,-6.49434 23.090971,-28.38266 23.331502,-29.46505 0,-0.12026 0.120265,-0.24053 0.120265,-0.48106 0,-0.72159 -0.721593,-1.32292 -1.443185,-1.32292 -0.841859,0 -4.810619,0.24053 -6.494336,0.24053 -1.803982,0 -6.133539,-0.24053 -6.855132,-0.24053 -0.841858,0 -2.285044,0.3608 -2.285044,1.80398 0,12.02655 -9.380707,25.37602 -12.267078,29.34478 l -0.601327,0.84186 c 0,0.12026 -0.120266,0.12026 -0.120266,0.24053 -0.120265,0.3608 -0.240531,0.84186 -0.240531,1.08239 0,0.96212 0.721593,1.68372 1.924248,1.68372 h 17.919555 v 6.01327 c 0,2.64584 -2.164778,3.36743 -3.848495,3.36743 -1.563451,0 -2.285044,0.84186 -2.285044,1.80398 0,0.96213 0.481062,2.04452 1.924248,2.04452 h 20.44513 c 0.962124,0 1.924248,-0.7216 1.924248,-2.04452 0,-1.32292 -1.202655,-1.92424 -2.164779,-1.92424 -0.962124,0 -2.886371,-0.60133 -2.886371,-3.60797 v -5.65247 h 6.975397 c 0.962124,0 1.443186,-0.7216 1.443186,-1.92425 0,-1.08239 -0.360797,-1.80398 -1.443186,-1.80398 z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTs64);
export default __webpack_public_path__ + "static/media/ts-6-4.3ad65c91220fc48103a0b956dedf96b3.svg";
export { ForwardRef as ReactComponent };